import * as React from 'react'

import {cn} from '../../lib/utils'

export interface InputDocProps {
  /** Ref to the input element (use instead of ref) */
  innerRef?: React.Ref<HTMLInputElement>
  /** Input type (text, email, password, etc.) */
  type?: string
  /** Placeholder text */
  placeholder?: string
  /** Current value */
  value?: string
  /** Change handler */
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  /** Whether the input is disabled */
  disabled?: boolean
}

// using the default ref doesn't seem to set the parent's ref object when mounted
// Since this is a shadCN component, we need to make sure to add back the innerRef prop,
// whenever the component is updated.
function Input({
  innerRef,
  className,
  type,
  ...props
}: React.ComponentProps<'input'> & {innerRef?: React.Ref<HTMLInputElement>}) {
  return (
    <input
      ref={innerRef}
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus:outline-none focus:ring-0 focus-visible:ring-0 focus-visible:outline-none',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  )
}

export {Input}
